module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/communication/snoozed-mail-9c8d5b1a4d17f29764960775b6c57dd4.svg";